function isLetterSelectionValid() {
  let isValid = true;

  document.querySelectorAll('.product__info-container').forEach(productMainEle => {
    const infiniteOptions = productMainEle.querySelector('#infiniteoptions-container');
    if (!infiniteOptions) return;

    const letterSelect = infiniteOptions.querySelector('select');
    const addToCartButton = productMainEle.querySelector('button[type="submit"]');
    if (!letterSelect || !addToCartButton) return;

    const selectedValue = letterSelect.value.trim();
    const existingError = infiniteOptions.querySelector('.variant_quantity_selector');

    if (!selectedValue) {
      isValid = false;
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled');

      if (!existingError) {
        const errorMsg = document.createElement('span');
        errorMsg.className = 'variant_quantity_selector';
        errorMsg.textContent = 'Select a letter from the dropdown above';
        infiniteOptions.appendChild(errorMsg);
      }
    } else {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('disabled');
      if (existingError) existingError.remove();
    }
  });
  return isValid;
}

// function setupValidationWatch() {
//   document.querySelectorAll('.product__info-container').forEach(productMainEle => {
//     const infiniteOptions = productMainEle.querySelector('#infiniteoptions-container');
//     if (!infiniteOptions) return;

//     const letterSelect = infiniteOptions.querySelector('select');
//     const addToCartButton = productMainEle.querySelector('button[type="submit"]');
//     if (!letterSelect || !addToCartButton) return;
//     if (!letterSelect.value.trim()) {
//       addToCartButton.disabled = true;
//       addToCartButton.classList.add('disabled');
//     }
//     letterSelect.addEventListener('change', isLetterSelectionValid);
//   });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   let attempts = 0;
//   const maxAttempts = 10;
//   const interval = setInterval(() => {
//     if (document.querySelector('#infiniteoptions-container select') || attempts >= maxAttempts) {
//       clearInterval(interval);
//       setupValidationWatch();
//       isLetterSelectionValid();
//     }
//     attempts++;
//   }, 300);
// });


var set_product = [];
function completeset_productadd(completeset_product) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: completeset_product
    },
    dataType: 'json',
    success: function(response) {
      
      if(set_product.length > 0){
        var productval = set_product.shift();
        completeset_productadd(productval); 
      }else{
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const cartDrawerhtml = html.querySelector('.cart-drawer');
            document.querySelector('.cart-drawer').innerHTML = cartDrawerhtml.innerHTML;
            const cartcounthtml = html.querySelector('.cartdrawer-count');
            if(document.querySelector('.cart-count-bubble')){
              //document.querySelector('.cart-count-bubble').innerHTML = cartcounthtml.innerHTML;
            }else{
              document.querySelector('.header__icon--cart').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true">1</span></div>';
              //document.querySelector('.cart-count-bubble').innerHTML = cartcounthtml.innerHTML;
            }
            document.querySelector('cart-drawer').classList.remove('is-empty');
            
          })
          .catch((e) => {
            console.error(e); 
          });
      }
    },
    error: function() {
    }
  });
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
              
        // if (!isLetterSelectionValid()) {
        //   return;
        // }


        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        // Add Accessories
         $('.product-add-accessories-block .block__complete-set-productcheckbox input[type="checkbox"]:checked').each(function(){
           var set_checked_val = $(this).attr('data-setvalid');
           set_product.push(set_checked_val);
            console.log(set_product.push(set_checked_val),'set_checked_val');
         });
        if($('.product-master__Content.add-masterclass-checked').length > 0){
          var set_productmaster_id = parseInt($('.product-master__Content.add-masterclass-checked .btn_action input[name="check_addon"]').val());
          set_product.push(set_productmaster_id);
        }else{}

        var productval = set_product.shift();   

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
                completeset_productadd(productval);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
  
}

var VariantFieldsetsa = document.querySelectorAll('variant-selects .product-form__input[data-opation]');
VariantFieldsetsa.forEach(fieldsetInner => {
    const opationValue = fieldsetInner.getAttribute('data-opation');
    const colorInputs = fieldsetInner.querySelectorAll('input[name="' + opationValue + '"]');
    const selectedColorSpan = fieldsetInner.querySelector('.option-name-selected-value');
    colorInputs.forEach(input => {
        input.addEventListener('change', function(e) {
          e.preventDefault();
            if (this.checked) {
                selectedColorSpan.textContent = this.value;
            }
        });
    });
}); 

